export const validation = {
  email: "Please enter a valid email address",
  validEmail: " Email address invalid",
};
